import React, { useEffect, useState } from 'react';
import './AboutPage.css';
import backgroundImage from '../assets/ai-hero.png';
import PageHeader from '../components/PageHeader';
import ContactForm from '../components/ContactForm';
import {  FaBrain,
  FaLock,
  FaRocket,
  FaHandshake,
  FaChartLine, FaInfoCircle, FaLightbulb, FaBullseye, FaLaptopCode, FaCloud, FaMobileAlt, FaRobot } from 'react-icons/fa';

const About = () => {
  const [counters, setCounters] = useState({
    years: 0,
    projects: 0,
    clients: 0,
  });

  useEffect(() => {
    const interval = setInterval(() => {
      setCounters((prev) => ({
        years: Math.min(prev.years + 1, 10),
        projects: Math.min(prev.projects + 10, 250),
        clients: Math.min(prev.clients + 1, 85),
      }));
    }, 50);

    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="about-section dark-mode"
      style={{
        marginTop: '0',
        paddingTop: '0',
        backgroundImage: `linear-gradient(to right, rgba(15, 23, 42, 0.95), rgba(30, 41, 59, 0.95)), url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed',
        color: 'white',
        padding: '0 0px 0px',
      }}
    >
      <PageHeader
        icon={<FaInfoCircle />}
        title="About Us"
        subtitle="Get to know our journey, mission, and impact."
        breadcrumb={[
          { label: 'Home', link: '/' },
          { label: 'About' },
        ]}
      />

      <div className="about-content container" style={{ maxWidth: '1000px', margin: '0 auto' }}>
        <p className="about-intro" style={{ fontSize: '1.2rem', marginBottom: '2rem', lineHeight: '1.8' }}>
         We architect intelligent digital solutions that convert vision into value, combining cutting-edge innovation with flawless execution to drive measurable impact. committed to empowering businesses with cutting-edge technology — turning ideas into intelligent digital solutions.
        </p>

        {/* Animated Counters */}
        <div className="about-counters" style={{ display: 'flex', justifyContent: 'space-between', gap: '20px', marginBottom: '3rem' }}>
          {[
            { value: counters.years, label: 'Years Experience' },
            { value: counters.projects, label: 'Projects Delivered' },
            { value: counters.clients, label: 'Satisfied Clients' },
          ].map((counter, index) => (
            <div key={index} style={{ textAlign: 'center' }}>
              <h3 style={{ fontSize: '2.5rem', marginBottom: '0.5rem', color: '#38bdf8' }}>{counter.value}+</h3>
              <p style={{ fontSize: '1rem' }}>{counter.label}</p>
            </div>
          ))}
        </div>

        {/* Vision & Mission */}
        <div className="vision-mission" style={{ display: 'flex', gap: '30px', marginBottom: '3rem' }}>
          <div style={{ flex: 1, background: '#1e293b', padding: '20px', borderRadius: '12px', textAlign: 'center' }}>
            <FaLightbulb size={32} color="#facc15" />
            <h4 style={{ marginTop: '10px', fontSize: '1.3rem', color: '#facc15' }}>Our Vision</h4>
            <p style={{ marginTop: '10px' }}>
              To lead the digital future by building transformative technology solutions that empower businesses worldwide.
            </p>
          </div>
          <div style={{ flex: 1, background: '#1e293b', padding: '20px', borderRadius: '12px', textAlign: 'center' }}>
            <FaBullseye size={32} color="#38bdf8" />
            <h4 style={{ marginTop: '10px', fontSize: '1.3rem', color: '#38bdf8' }}>Our Mission</h4>
            <p style={{ marginTop: '10px' }}>
              Deliver high-performance, secure, and scalable digital products through innovation, collaboration, and expertise.
            </p>
          </div>
        </div>

        {/* Key Features */}
        <ul className="about-list" style={{ fontSize: '1.1rem', marginBottom: '3rem', paddingLeft: '1.5rem' }}>
       <li>
    <FaBrain style={{ marginRight: '8px', color: '#a78bfa' }} />
    Experts in AI, Web, Cloud & Mobile
  </li>
  <li>
    <FaLock style={{ marginRight: '8px', color: '#f87171' }} />
    Focused on performance and security
  </li>
  <li>
    <FaRocket style={{ marginRight: '8px', color: '#60a5fa' }} />
    <strong>Scalable Cloud Architecture</strong> - AWS/Azure/GCP-optimized infrastructure with auto-scaling
  </li>
  <li>
    <FaHandshake style={{ marginRight: '8px', color: '#34d399' }} />
    <strong>Client-Centric Approach</strong> - Agile development with transparent communication
  </li>
  <li>
    <FaChartLine style={{ marginRight: '8px', color: '#facc15' }} />
    <strong>Results-Driven</strong> - Focused on measurable business outcomes and ROI
  </li>
        </ul>

        {/* Tech Stack Icons */}
        <div className="tech-stack" style={{ marginBottom: '3rem' }}>
          <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#38bdf8' }}>💻 Technologies We Excel In</h3>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px', fontSize: '2rem' }}>
            <FaLaptopCode title="Web Development" color="#38bdf8" />
            <FaMobileAlt title="Mobile Apps" color="#34d399" />
            <FaCloud title="Cloud Infrastructure" color="#60a5fa" />
            <FaRobot title="AI / ML" color="#facc15" />
            {/* Add more icons if needed */}
          </div>
        </div>
{/* Proven Approach Section */}
<div className="proven-approach" style={{ marginTop: '4rem', marginBottom: '4rem' }}>
  <h2 style={{ fontSize: '2rem', marginBottom: '1rem', textAlign: 'center', color: '#38bdf8' }}>
  Driving Success Through the Novacrest Methodology
  </h2>
  <p style={{ textAlign: 'center', maxWidth: '700px', margin: '0 auto 3rem auto', fontSize: '1.1rem' }}>
  Unlock measurable outcomes with our proven framework — built on strategic planning, data-driven insights, and consistent execution.
  </p>

  <div style={{ display: 'grid', gap: '30px', gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))' }}>
    {[

{
  step: 'Step 1',
  title: 'Understand Pattern Identification',
  desc: 'Novacrest begins by examining data to uncover meaningful trends and behavioral patterns that serve as the foundation for intelligent solutions.',
},
{
  step: 'Step 2',
  title: 'Pattern Mapping User Stories',
  desc: 'We organize user stories around identified patterns, ensuring product development stays aligned with user intent and system logic.',
},
{
  step: 'Step 3',
  title: 'Wireframe and Front-End',
  desc: 'Our design team translates mapped stories into wireframes and front-end layouts, creating intuitive, user-centric interfaces.',
},
{
  step: 'Step 4',
  title: 'Model Development and Training',
  desc: 'We build and train machine learning models using structured data patterns to deliver automation and predictive intelligence.',
},
{
  step: 'Step 5',
  title: 'Development and Deployment',
  desc: 'Finally, we integrate the trained models into production systems and ensure seamless deployment across relevant environments.',
}

    ].map((item, i) => (
      <div key={i} className="step-card" style={{
        background: '#1e293b',
        padding: '20px',
        borderRadius: '12px',
        textAlign: 'center',
        borderTop: '4px solid #38bdf8',
        boxShadow: '0 4px 14px rgba(0,0,0,0.2)',
      }}>
        <h4 style={{ color: '#facc15', fontSize: '1rem', marginBottom: '0.5rem' }}>{item.step}</h4>
        <h3 style={{ fontSize: '1.2rem', color: '#e2e8f0', marginBottom: '0.5rem' }}>{item.title}</h3>
        <p style={{ color: '#cbd5e1', fontSize: '1rem' }}>{item.desc}</p>
      </div>
    ))}
  </div>
</div>


        {/* Timeline */}
        <div className="about-timeline">
          <h3 style={{ fontSize: '1.5rem', marginBottom: '1rem', color: '#facc15' }}>🚀 Company Milestones</h3>
          <ul style={{ lineHeight: '1.8' }}>
            <li>
    <strong>2014:</strong> Founded with vision to bridge technology and business innovation
  </li>
              <li> <strong>2016:</strong> Strategic partnership with First Nations communities - delivered 15+ indigenous tech initiatives
  </li>
            <li><strong>2017:</strong> Built 24/7 global support team</li>
          
  
            <li><strong>2019:</strong> AI/ML Division Launched</li>
             <li>
    <strong>2020:</strong> Helped clients achieve 300% ROI in 6 months</li>
<li><strong>2021:</strong> Launched industry-specific solutions</li>
   <li> <strong>2023:</strong> Product suite expansion - launched 3 new SaaS platforms
  </li>
          
            <li><strong>2024:</strong> Reached 250+ Projects</li>
          </ul>
        </div>
        
        <ContactForm />
      
      </div>
    </section>


  );
};

export default About;
